import { useMemo } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

const setOperatorBadge = (badge: string) => {
  localStorage.receivementOperatorBadge = badge
}

const setOperatorName = (name: string) => {
  localStorage.operatorName = name
}

const setSupervisorBadge = (badge: string) => {
  localStorage.receivementSupervisorBadge = badge
}

export const useReceivement = ({
  valideOperator = false,
  validateSupervisor = false,
  reset = false,
} = {}) => {
  const history = useHistory()
  const location = useLocation()
  const { receivementId } = useParams<{ receivementId: string }>()

  if (reset) {
    localStorage.removeItem('receivementOperatorBadge')
    localStorage.removeItem('receivementSupervisorBadge')
  }

  const operatorBadge = useMemo<string>(() => localStorage.receivementOperatorBadge, [])
  const supervisorBadge = useMemo<string>(
    () => localStorage.receivementSupervisorBadge,
    [],
  )
  const operatorName = useMemo<string>(() => localStorage.operatorName, [])

  if (valideOperator && !operatorBadge && !operatorName) {
    history.push('/receivement')
  }

  if (validateSupervisor && !supervisorBadge) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`)

    let url = `/supervisor/login?next=${next}`

    if (receivementId) {
      url = url.concat(`&receivementId=${receivementId}`)
    }

    history.push(url)
  }

  return {
    operatorBadge,
    supervisorBadge,
    operatorName,
    setOperatorBadge,
    setSupervisorBadge,
    setOperatorName,
  }
}
